module.exports = __webpack_public_path__ + "static/img/main-termsofuse__icon.9b266fb2.svg";